export default __webpack_public_path__ + "92e576478878958d0d45bac55a0496b3.png";